


export const openAddWorkerDialogReducer = (state) => {
    
    state.addWorkerDialog.isOpen = true;
    state.createNewWorker.status = "idle";
    state.createNewWorker.errorMessage = "";
  }